<script setup lang="ts">
import { PRIVACY_POLICY_URL } from '@/shared/constants/urlConstants';

defineOptions({
  name: 'CookiesPanel',
});

const emit = defineEmits(['accept']);

const isMobile: boolean = useIsMobile();

const acceptCookies = () => {
  emit('accept');
};
</script>

<template>
  <div :class="['cookies-panel', { _mobile: isMobile }]">
    <div class="cookies-panel__inner">
      <div class="cookies-panel__text">
        Используем cookies для работы сайта.
        <NuxtLink class="cookies-panel__link" :to="PRIVACY_POLICY_URL">
          Подробнее
        </NuxtLink>
      </div>
      <div class="cookies-panel__buttons-wrapper">
        <AppButton
          class="cookies-panel__button _required"
          button-text="Только обязательные"
          type="button"
          is-white
          is-bordered
          :is-full-width="isMobile"
          @click="acceptCookies"
        />
        <AppButton
          class="cookies-panel__button _accept"
          button-text="Принять все"
          type="button"
          :is-full-width="isMobile"
          @click="acceptCookies"
        />
      </div>
    </div>
  </div>
</template>

<style lang="less">
.cookies-panel {
  .container-d();

  position: fixed;
  left: 0;
  right: 0;
  bottom: 60px;
  z-index: 1000;
  pointer-events: none;

  &__inner {
    .box-shadow();

    display: inline-flex;
    align-items: center;
    gap: @size-x6;
    max-width: 730px;
    padding: @size-x3;
    background-color: #fff;
    border: 1px solid @color-alto;
    border-radius: @size-x3;
    pointer-events: auto;
  }

  &__text {
    font-size: 14px;
    font-weight: 500;
    line-height: 130%;
    margin-right: auto;
  }

  &__link {
    display: inline-block;
    color: @color-elephant;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover {
      text-decoration: none;
    }
  }

  &__buttons-wrapper {
    display: flex;
    gap: @size-x6;
    flex-shrink: 0;
  }

  & &__button {
    width: auto;
    height: 40px;
    min-height: 40px;
    padding: 0 @size-x4;
    white-space: nowrap;
  }

  &._mobile {
    .container-m();

    bottom: @size-x5;
  }

  &._mobile &__inner {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: @size-x4;
    width: 100%;
    padding: @size-x4;
  }

  &._mobile &__text {
    margin-right: 0;
  }

  &._mobile &__buttons-wrapper {
    flex-direction: column;
    gap: @size-x3;
  }

  &._mobile &__button {
    width: 100%;
  }
}
</style>
